module.exports = __webpack_public_path__ + "img/10micron_p.639c2c10.jpg";